module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("First I must thank Barry Gaspar of Duke University, general editor of this series, for originally suggesting the idea for this book and Joan Catapano of Indiana University Press for supporting the project. Kate Babbitt provided meticulous copyediting, and Linda Opper helped with retyping. Jim Sloan of the University of Florida geography department drew the maps. The comte de Chamski-Man-dajors, Dr. Marcel Châtillon, Jean-Louis Clavière, Lord Colville of Culross, the late Gabriel Debien, and Mrs Phyllis Spencer Bernard gave permission to consult or loaned copies of documents in their possession. Marixa Lasso, Paul Lokken, and Douglas Tompson provided invaluable leads to sources for ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _vm._v(". I am extremely grateful to all of them for their help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Research for these chapters stretches back to the early 1970s. It has received generous financial support from University of Florida research and travel grants and, in the form of fellowships, from the British Academy “Thank-Offering to Britain” fund, the John Simon Guggenheim Foundation, the National Endowment for the Humanities, the National Humanities Center, the Social Science Research Council, and the Woodrow Wilson Center for International Scholars. I am greatly indebted to these institutions and their staffs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Earlier versions of eleven of the thirteen chapters previously have appeared in other publications. I am most grateful to their publishers for kind permission to reuse the material in this work. Original publication details are listed below.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(", “The Haitian Revolution,” is from "), _c('i', [_vm._v("The Modern Caribbean")]), _vm._v(", ed. Franklin W. Knight and Colin Palmer, 21–50. Copyright © 1989 by the University of North Carolina Press. Used by permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter02"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" was first published as “The Haitian Revolution: New Approaches and Old,” "), _c('i', [_vm._v("Proceedings of the 19th Meeting of the French Colonial Historical Society")]), _vm._v(", ed. James Pritchard (Cleveland: French Colonial Historical Society, 1994), 141–155.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" was first published as “Unexploited Sources for the History of the Haitian Revolution,” in "), _c('i', [_vm._v("Latin American Research Review")]), _vm._v(" 18, no. 1 (1983): 95–103.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(", “The Causation of Slave Rebellions: An Overview,” is from "), _c('i', [_vm._v("Indian Historical Review")]), _vm._v(" 15 (1988): 116–129.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" was first published as “Marronage, Voodoo, and the Saint Domingue Slave Revolt,” in "), _c('i', [_vm._v("Proceedings of the 15th Meeting of the French Colonial Historical Society, Martinique and Guadeloupe, May 1989")]), _vm._v(", ed. Philip Boucher and Patricia Galloway (Lanham, Md.: University Press of America, 1992), 22–35.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(", “The Bois Caïman Ceremony,” is from "), _c('i', [_vm._v("Journal of Caribbean History")]), _vm._v(" 25 (1991): 41–57.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" was first published as “From His Most Catholic Majesty to the Godless République: The Volte-Face of Toussaint Louverture and the Ending of Slavery in Saint-Domingue,” "), _c('i', [_vm._v("Revue Française d’Histoire d’Outre-Mer")]), _vm._v(" 65 (1978): 481–499.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(", “Slave, Soldier, Rebel: The Strange Career of Jean Kina,” is from "), _c('i', [_vm._v("Jamaican Historical Review")]), _vm._v(" 12 (1980): 33–51.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(", “Racial Equality, Slavery, and Colonial Secession during the Constituent Assembly,” is from the "), _c('i', [_vm._v("American Historical Review")]), _vm._v(" 94 (1989): 1290–1308. By permission of the American Historical Association.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(", “The Great Powers and the Haitian Revolution,” is from "), _c('i', [_vm._v("Tordesillas y sus consecuencias: La política de las grandes potencias europeas respecto a América Latina (1494–1898)")]), _vm._v(", ed. Bernd Schröter and Karin Schüller (Madrid: Iberoamericana, and Frankfurt am Main: Vervuert Verlag, 1995), 113–125.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _vm._v(", “The Naming of Haiti,” was first published in "), _c('i', [_vm._v("New West Indian Guide")]), _vm._v(" 71, no. 1/2 (1997): 43–68.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentta"
  }, [_vm._v("The map on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#page_4"
    }
  }, [_vm._v("page 4")]), _vm._v(" is used by permission of Oxford University Press and first appeared in David Patrick Geggus, "), _c('i', [_vm._v("Slavery, War and Revolution: The British Occupation of Saint Domingue, 1793–1798")]), _vm._v(" (Oxford: Oxford University Press, 1982), © David Patrick Geggus 1982.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc0f6fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Acknowledgement.vue
// module id = 75
// module chunks = 0